import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Nav } from "react-bootstrap";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
} from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
import "./AccountDetailsTabsV2.css";
import * as FeatherIcon from "react-feather";
import ExecutiveSnapshot from "./CompetitorTabs/ExecutiveSnapshot/ExecutiveSnapshot";
import News from "./CompetitorTabs/News/News";
import ProfileMarketPosition from "./CompetitorTabs/ProfileMarketPosition/ProfileMarketPosition";
import ProfileProductInnovation from "./CompetitorTabs/ProfileProductInnovation/ProfileProductInnovation";
import FinancialsComp from "./CompetitorTabs/ProfileFinancials/FinancialsComp";
import Marketing from "./CompetitorTabs/Marketing/Marketing";
import Operations from "./CompetitorTabs/Operations/Operations";
import OrgStructure from "./CompetitorTabs/OrgStructure/OrgStructure";
import APP_CONFIG from "../../../config/appConfig";
import NewUpdates from "./NewUpdates/NewUpdates";
import NewCompProfileUpdates from "./CompetitorTabs/NewCompProfileUpdates";
import { fetchNewUpdatesRequest } from "../../../store/features/actions/newUpdatesActions";

function CompProfileTabs({
  displayCompProfileUpdatesSection,
  activeParentTabKey,
  setParentActiveTab,
  compView,
  existingSubdimensions,
  setAiBuilderDimensionOptions,
}) {
  const navigate = useNavigate();
  const { user } = useUser();
  const dispatch = useDispatch();
  // console.log("user",user)
  const { clientName, competitorName, accountId, accountName } = useParams();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabFromUrl = searchParams.get("tab") || "executiveSnap";

  const [dynamicTabsMap, setDynamicTabsMap] = useState({});

  const registerDynamicTabs = useCallback((parentKey, tabs = []) => {
    setDynamicTabsMap((prev) => ({
      ...prev,
      [parentKey]: tabs,
    }));
  }, []);

  useEffect(() => {
    setDynamicTabsMap({});
  }, [competitorName]);
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++
  const [selectedAction, setSelectedAction] = useState("");
  const { data: updatesData, loading } = useSelector(
    (state) => state.newUpdatesReducer
  );

  // console.log("Updates data from Redux: " + JSON.stringify(updatesData));

  const handleActionChange = (action) => {
    setSelectedAction(action);
  };

  const subdimensionArray = useMemo(() => {
    return updatesData?.[selectedAction] || [];
  }, [updatesData, selectedAction]);
  // const [subdimensionArray, setSubdimensionArray] = useState([]);

  // const updates = {
  //   added: ["Company Overview", "Market Presence"],
  //   removed: ["Financial Performance"],
  //   update_in_progress: ["Operations & Supply Chain"],
  //   update_completed: ["Leadership Team"],
  // };

  // const handleActionChange = (action) => {
  //   setSelectedAction(action);
  //   setSubdimensionArray(updates[action] || []);
  // };

  const scorecardElements = [
    "FinancialsStrategy_ScoreCard",
    "MarketPosition_ScoreCard",
    "MarketingDistributions_ScoreCard",
    "OpsSupply_ScoreCard",
    "OrgLeader_ScoreCard",
    "ProdInno_ScoreCard",
  ];
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++

  const [accountContactList, setAccountContactList] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState({});
  const scrollContainerRef = useRef(null);
  // const marketIqClient = "Oracle Corporation";
  const clientCompanyType = user?.demo;
  const marketIqClient = "H.B. Fuller";
  const nonMarketIqTabs = [
    "profileMarketPosition",
    "financials",
    "orgStructure",
    "news",
  ];
  const nonMarketIqSubTabs = [
    //product innovation subtabs
    "insightSummary",
    "productInnovationSolutions",
    "productLaunches",
    "patentsIp",
    "technologyCapability",
    "customerValueProposition",
    "strategicRiskMatrix",
    //Marketing & Distribution subtabs
    "insightSummaryTabM",
    "gtmModelTab",
    // "channelMixUtilizationTab",         // Channel mix and utilization in marketing distribution tab displayed to market iq users as asked by Payal
    "demandGenerationAcquisitionTacticsTab",
    "marketingInvestmentROISignalsTab",
    "marketPresenceBrandSignalsTab",
    "messagingPositioningTab",
    "digitalFootprintAnalysisTab",
    "advertisingMediaSpendTab",
    "marketingChannelsbySegmentTab",
    "marketingGeographicCoverageTab",
    // Operation & Supply chain subtabs
    "operationsInsightTab",
    "tier1SuppliersTab",
    "sustainabilityFinanceInnovationRisksTab",
  ];

  // +++++++++++++++++++++++++++++++++++++++++++++++
  const [subItemDataStatus, setSubItemDataStatus] = useState({});
  // const handleSubItemDataCheck = useCallback((subItemKey, hasData) => {
  //   setSubItemDataStatus((prev) => ({
  //     ...prev,
  //     [subItemKey]: hasData,
  //   }));
  // }, []);
  // console.log(
  //   "EXISTING SUB_DIMENSIONS PASSED TO PARENT: " +
  //     JSON.stringify(existingSubdimensions)
  // );
  const useExistingSubdimensions =
    Array.isArray(existingSubdimensions?.data) &&
    existingSubdimensions?.data.length > 0;

  // console.log("useExistingSubdimensions: ", useExistingSubdimensions);
  const handleSubItemDataCheck = useCallback(
    (subItemKey, hasData) => {
      if (useExistingSubdimensions) return; // ignore data availability

      setSubItemDataStatus((prev) => ({
        ...prev,
        [subItemKey]: hasData,
      }));
    },
    [useExistingSubdimensions]
  );
  // +++++++++++++++++++++++++++++++++++++++++++++++

  // add / replace where you declare activeSubKey
  const [activeSubKey, setActiveSubKey] = useState(
    searchParams.get("tab") || null
  );

  // ++++++++++++++++++++++++++++++++++++++
  // Local search
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const sectionMap = useRef({});

  const programmaticScrollRef = useRef(null);

  const [scrollTarget, setScrollTarget] = useState(null);

  // Inside CompProfileTabs.jsx

  const registerSectionRef = useCallback((key, element) => {
    if (element) {
      // 1. Store the element for regular scroll-spy logic
      sectionMap.current[key] = element;

      // 2. CHECK: Is this the specific key the user just searched for?
      if (programmaticScrollRef.current === key) {
        // console.log("Match found! Scrolling to:", key);

        // We use a small delay to ensure the Skeleton is fully unmounted
        // and the browser has calculated the new heights.
        setTimeout(() => {
          const yOffset = -120; // Adjustment for your header
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });

          // 3. Reset the target so it doesn't jump on every re-render
          programmaticScrollRef.current = null;
        }, 100);
      }
    }
  }, []);
  // ++++++++++++++++++++++++++++++++++++++

  // keep state in sync if URL changes or parent tab changes
  useEffect(() => {
    const tabFromUrl = searchParams.get("tab") || activeParentTabKey;
    setActiveSubKey(tabFromUrl);
  }, [searchParams, activeParentTabKey]);

  const toggleExpand = (key) => {
    setExpandedKeys((prev) => {
      const isCurrentlyExpanded = !!prev[key];
      // collapse all → then expand only the clicked one (if it wasn’t already open)
      return isCurrentlyExpanded ? {} : { [key]: true };
    });
  };
  const handleSetActiveSubKey = useCallback(
    (key) => {
      setActiveSubKey(key);
      setSearchParams({ tab: key });
    },
    [setSearchParams]
  );

  // ############################################
  // subtab keys mapped to subdimension names coming from existing sub-dimensions (schema) API
  const subdimensionKeyMap = {
    // execCompanyOverviewTab: "Company Overview",
    // insightSummaryTab: "Insight Summary",
    // overallCompetitiveThreatAssessmentTab:
    //   "Overall Competitive Threat Assessment",
    // companyScorecardTab: "Company Scorecard",
    // companyBaselineProfileTab: "Company Baseline Profile",

    // Executive snapshot dimension/Tabs
    // insightSummaryTab: "",
    execCompanyOverviewTab: "Company Overview",
    overallCompetitiveThreatAssessmentTab:
      "Overall_Competitive_Threat_Assessment",
    companyScorecardTab: "COMPANY_SCORECARD",
    businessSegmentStructureTab: "Business Segment",
    companyBaselineProfileTab: "",
    competitiveIntelligenceDashboardTab: "",
    executiveSummaryNextStepsTab: "Executive_Summary_Next_Steps",

    // Market position dimension/tabs
    // insightSummaryTabMp: "",
    marketByTechnologyTab: "Market by technology",
    marketByApplicationTab: "Market by application",
    marketByGeographyTab: "Market by geography",
    marketShareAnalysisTab: "Market Share Analysis",
    customerSegmentAnalysisTab: "Customer Segment Analysis",
    keyExpansionsStrategicInitiativesTab:
      "Key Expansions & Strategic Initiatives",

    // Product innovation dimension/tabs
    // insightSummary: "",
    productInnovationSolutions: "Product & Solution Portfolio",
    // "compPosition:"",,
    productLaunches: "Product Launches & Related Activities",
    patentsIp: "Patents & IP Activity",
    technologyCapability: "Technology Capability Assessment",
    customerValueProposition: "Customer Value Proposition Analysis",
    strategicRiskMatrix: "Strategic Risk Matrix",
    rdSpendEstimates: "R&D Spend Estimates",
    rdFocus: "R&D Spend Estimates",
    innovationTheme: "Innovation Theme Radar",

    // Financial dimension/tabs
    strategicLeadershipThemesTab: "Strategic Themes",
    financialsTable: "",
    futureBetsLeadershipLedInitiativesTabf: "Future Bets",
    financialDocuments: "",

    // Marketing distribution dimension/tabs
    // insightSummaryTabM: "",
    gtmModelTab: "GTM & Distribution Strategy Analysis",
    distributionNetworksPartnershipsTab: "GTM & Distribution Strategy Analysis",
    channelMixUtilizationTab: "GTM & Distribution Strategy Analysis",
    demandGenerationAcquisitionTacticsTab:
      "Demand Generation & Acquisition Tactics",
    marketingInvestmentROISignalsTab: "Marketing Investment & ROI Signals",
    marketPresenceBrandSignalsTab: "Market Presence & Brand Signals",
    messagingPositioningTab: "Messaging & Positioning",
    digitalFootprintAnalysisTab: "Digital Footprint Analysis",
    advertisingMediaSpendTab: "Advertising & Media Spend",
    marketingChannelsbySegmentTab: "Marketing Channels by Segment",
    marketingGeographicCoverageTab: "Marketing Geographic Coverage",

    // Org structure dimension/tabs
    executiveTimelineTab: "Executive Timeline",
    executiveLeadershipTeamTab: "Executive Leadership Team",
    organizationalHierarchyTab: "Org Chart",
    // businessSegmentStructureTab: "Business Segment",
    // strategicLeadershipThemesTab: "Strategic Themes",
    // "futureBetsLeadershipLedInitiativesTab",

    // Operations dimension/tabs
    // operationsInsightTab: "",
    quantSnapshotTab: "Quantitative Snapshot",
    globalOperationsNetworkTab: "Global Operations Network",
    capexTrendsTab: "Capex Trends",
    tier1SuppliersTab: "Tier 1 Suppliers",
    rawMaterialImportsTab: "Raw Material Imports",
    inboundLogisticsTab: "Inbound Logistics",
    warehousingChannelsTab: "Warehousing & Channels",
    outboundDistributionTab: "Outbound Distribution",
    tradeExposureTab: "Trade Exposure",
    costStructureAnalysisTab: "Cost Structure Analysis",
    sustainabilityFinanceInnovationRisksTab:
      "Sustainability, Finance, Innovation, Risks",
  };
  // ############################################

  //Tab subtabs
  const executiveSnapTabs = [
    "execCompanyOverviewTab",
    "insightSummaryTab",
    "overallCompetitiveThreatAssessmentTab",
    "companyScorecardTab",
    "companyBaselineProfileTab",
    "competitiveIntelligenceDashboardTab",
    "executiveSummaryNextStepsTab",
    "businessSegmentStructureTab",
  ];

  const marketPositionTabs = [
    "insightSummaryTabMp",
    "marketByTechnologyTab",
    "marketByApplicationTab",
    "marketByGeographyTab",
    "marketShareAnalysisTab",
    "customerSegmentAnalysisTab",
    "keyExpansionsStrategicInitiativesTab",
  ];
  const productInnovationTabs = [
    "insightSummary",
    "productInnovationSolutions",
    // "compPosition",
    "productLaunches",
    "patentsIp",
    "technologyCapability",
    "customerValueProposition",
    "strategicRiskMatrix",
    "rdSpendEstimates",
    "rdFocus",
    "innovationTheme",
  ];

  const financialTabs = [
    "financialsTable",
    "futureBetsLeadershipLedInitiativesTabf",
    "financialDocuments",
    "strategicLeadershipThemesTab",
  ];

  const marketingDistributionTabs = [
    "insightSummaryTabM",
    "gtmModelTab",
    "distributionNetworksPartnershipsTab",
    "channelMixUtilizationTab",
    "demandGenerationAcquisitionTacticsTab",
    "marketingInvestmentROISignalsTab",
    "marketPresenceBrandSignalsTab",
    "messagingPositioningTab",
    "digitalFootprintAnalysisTab",
    "advertisingMediaSpendTab",
    "marketingChannelsbySegmentTab",
    "marketingGeographicCoverageTab",
  ];
  const orgStructureTabs = [
    "executiveTimelineTab",
    "executiveLeadershipTeamTab",
    "organizationalHierarchyTab",
    // "businessSegmentStructureTab",
    // "strategicLeadershipThemesTab",
    // "futureBetsLeadershipLedInitiativesTab",
  ];

  const operationsTabs = [
    "operationsInsightTab",
    "quantSnapshotTab",
    "globalOperationsNetworkTab",
    {
      /*"capexTrendsTab"*/
    },
    "tier1SuppliersTab",
    "rawMaterialImportsTab",
    "inboundLogisticsTab",
    "warehousingChannelsTab",
    "outboundDistributionTab",
    "tradeExposureTab",
    "costStructureAnalysisTab",
    "sustainabilityFinanceInnovationRisksTab",
  ];

  // +++++++++++++++++++++++++++++++++++++++++++++++++++
  // let executiveSnapUpdate = 0;
  // let newsUpdate = 0;
  // let proMarPositionUpdate = 0;
  // let proProdInnovationUpdate = 0;
  // let financialsUpdate = 0;
  // let marketingUpdate = 0;
  // let operationsUpdate = 0;
  // let orgStructureUpdate = 0;

  // Replace the old let executiveSnapUpdate = 0; etc. with this:
  const hasUpdates = useMemo(() => {
    if (!updatesData)
      return {
        exec: 0,
        market: 0,
        prod: 0,
        marketing: 0,
        operations: 0,
        orgStructure: 0,
      };

    // Combine all subdimensions from all update categories into one flat array
    // const allUpdatedSubdimensions = Object.values(updatesData).flat();
    const allUpdatedSubdimensions = Object.entries(updatesData)
      .filter(([key]) => key !== "added")
      .flatMap(([, value]) => value);

    // Check Executive Snapshot
    const execHasUpdate = executiveSnapTabs.some((tabKey) => {
      const dimensionName = subdimensionKeyMap[tabKey];
      return allUpdatedSubdimensions.includes(dimensionName);
    });

    // Check Market Position
    const marketHasUpdate = marketPositionTabs.some((tabKey) => {
      const dimensionName = subdimensionKeyMap[tabKey];
      return allUpdatedSubdimensions.includes(dimensionName);
    });

    // Check Product Innovation
    const productHasUpdate = productInnovationTabs.some((tabKey) => {
      const dimensionName = subdimensionKeyMap[tabKey];
      // console.log(
      //   "\nDIMENSION NAME: " +
      //     dimensionName +
      //     " Status: " +
      //     allUpdatedSubdimensions.includes(dimensionName)
      // );
      return allUpdatedSubdimensions.includes(dimensionName);
    });

    // Check Marketing & Distribution
    const marketingHasUpdate = marketingDistributionTabs.some((tabKey) => {
      const dimensionName = subdimensionKeyMap[tabKey];
      return allUpdatedSubdimensions.includes(dimensionName);
    });

    // Check Operations
    const operationsHasUpdate = operationsTabs.some((tabKey) => {
      const dimensionName = subdimensionKeyMap[tabKey];
      return allUpdatedSubdimensions.includes(dimensionName);
    });

    // Check Org structure
    const orgStructureHasUpdate = orgStructureTabs.some((tabKey) => {
      const dimensionName = subdimensionKeyMap[tabKey];
      return allUpdatedSubdimensions.includes(dimensionName);
    });

    return {
      exec: execHasUpdate ? 1 : 0,
      market: marketHasUpdate ? 1 : 0,
      prod: productHasUpdate ? 1 : 0,
      marketing: marketingHasUpdate ? 1 : 0,
      operations: operationsHasUpdate ? 1 : 0,
      orgStructure: orgStructureHasUpdate ? 1 : 0,
    };
  }, [updatesData]);

  // const executiveSnapUpdate = hasUpdates.exec;
  // const proMarPositionUpdate = hasUpdates.market;
  const executiveSnapUpdate = hasUpdates.exec;
  const proMarPositionUpdate = hasUpdates.market;
  const proProdInnovationUpdate = hasUpdates.prod;
  const marketingUpdate = hasUpdates.marketing;
  const operationsUpdate = hasUpdates.operations;
  const orgStructureUpdate = hasUpdates.orgStructure;
  const financialsUpdate = 0;
  const newsUpdate = 0;
  // +++++++++++++++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    let scrollTimeout = null;

    const handleScroll = () => {
      if (programmaticScrollRef.current) return;

      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        const scrollY = window.scrollY + 120;

        let foundKey = null;

        Object.entries(sectionMap.current).forEach(([key, el]) => {
          if (!el) return;
          const top = el.offsetTop;
          const height = el.offsetHeight;

          if (scrollY >= top && scrollY < top + height) {
            foundKey = key;
          }
        });

        if (foundKey) {
          // parent or child, your logic
          setActiveSubKey(foundKey);
        }
      }, 140);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (activeTabFromUrl !== activeParentTabKey) {
      if (activeTabFromUrl !== null) {
        setActiveSubKey(activeTabFromUrl);
      } else {
        setParentActiveTab(activeTabFromUrl);
      }
    }
  }, [activeTabFromUrl]);

  useEffect(() => {
    // console.log("IN PARENT TAB EFFECT: " + activeParentTabKey);
    const tabTypeMap = {
      executiveSnap: "Executive Snapshot",
      news: "News",
      profileMarketPosition: "Market Position",
      profileProductInnovation: "Product & Innovation",
      financials: "Financials",
      marketing: "Marketing",
      operations: "Operations",
      orgStructure: "Org Structure",
    };

    const tabType = tabTypeMap[activeParentTabKey];
    if (tabType) {
      pageParsedData.query_params = { tab: activeParentTabKey };
      const userStat = getUserStatsObject(
        tabType,
        "page_load",
        `Page Source: ${accountName}`,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [activeParentTabKey]);

  useEffect(() => {
    if (activeTabFromUrl && programmaticScrollRef.current) {
      programmaticScrollRef.current = null;
    }
  }, [activeTabFromUrl]);

  const handleTabChange = useCallback(
    (key, hasChildren = false) => {
      const parentTabs = [
        "executiveSnap",
        "news",
        "profileMarketPosition",
        "profileProductInnovation",
        "financials",
        "marketing",
        "operations",
        "orgStructure",
      ];

      if (parentTabs.includes(key)) {
        // direct parent tab click
        setParentActiveTab(key);
        // setSearchParams({ tab: key });
        handleSetActiveSubKey(key);

        if (hasChildren && filteredTabItems) {
          const parent = filteredTabItems.find((t) => t.key === key);
          const firstChildKey = parent?.children?.[0]?.key;

          if (firstChildKey) {
            handleSetActiveSubKey(firstChildKey); // set first child as active
          }

          setExpandedKeys((prev) => {
            const isExpanded = prev[key]; // check if it's currently expanded
            return isExpanded ? {} : { [key]: true }; // collapse if expanded, otherwise expand
          });
        } else {
          handleSetActiveSubKey(key); // no children → set parent as active
          setExpandedKeys({}); // collapse all
        }
      } else {
        // subtab click → figure out its parent

        if (executiveSnapTabs.includes(key)) {
          setParentActiveTab("executiveSnap");
          setExpandedKeys({ executiveSnap: true });
        } else if (marketPositionTabs.includes(key)) {
          setParentActiveTab("profileMarketPosition");
          setExpandedKeys({ profileMarketPosition: true });
        } else if (productInnovationTabs.includes(key)) {
          setParentActiveTab("profileProductInnovation");
          setExpandedKeys({ profileProductInnovation: true });
        } else if (financialTabs.includes(key)) {
          setParentActiveTab("financials");
          setExpandedKeys({ financials: true });
        } else if (marketingDistributionTabs.includes(key)) {
          setParentActiveTab("marketing");
          setExpandedKeys({ marketing: true });
        } else if (operationsTabs.includes(key)) {
          setParentActiveTab("operations");
          // setExpandedKeys({ orgStructure: true });
          setExpandedKeys({ operations: true });
        } else if (orgStructureTabs.includes(key)) {
          setParentActiveTab("orgStructure");
          setExpandedKeys({ orgStructure: true });
        }

        // setSearchParams({ tab: key });
        handleSetActiveSubKey(key);
      }
    },
    [handleSetActiveSubKey]
  );

  // const renderContent = () => {
  //   const currentTab = searchParams.get("tab") || activeParentTabKey;

  //   // define subtabs mapping here (inside renderContent, so they’re in scope)

  //   // normalize parent key
  //   let normalizedParent = activeParentTabKey;
  //   if (executiveSnapTabs.includes(currentTab)) {
  //     normalizedParent = "executiveSnap";
  //   } else if (marketPositionTabs.includes(currentTab)) {
  //     normalizedParent = "profileMarketPosition";
  //   } else if (productInnovationTabs.includes(currentTab)) {
  //     normalizedParent = "profileProductInnovation";
  //   } else if (financialTabs.includes(currentTab)) {
  //     normalizedParent = "financials";
  //   } else if (marketingDistributionTabs.includes(currentTab)) {
  //     normalizedParent = "marketing";
  //   } else if (operationsTabs.includes(currentTab)) {
  //     normalizedParent = "operations";
  //   } else if (orgStructureTabs.includes(currentTab)) {
  //     normalizedParent = "orgStructure";
  //   }

  //   switch (normalizedParent) {
  //     case "executiveSnap":
  //       return (
  //         <ExecutiveSnapshot
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //           scrollTargetRef={programmaticScrollRef}
  //           registerSectionRef={registerSectionRef}
  //         />
  //       );
  //     case "news":
  //       return <News />;
  //     case "profileMarketPosition":
  //       return (
  //         <ProfileMarketPosition
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //         />
  //       );
  //     case "profileProductInnovation":
  //       return (
  //         <ProfileProductInnovation
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //         />
  //       );
  //     case "financials":
  //       return (
  //         <FinancialsComp
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //         />
  //       );
  //     case "marketing":
  //       return (
  //         <Marketing
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //         />
  //       );
  //     case "operations":
  //       return (
  //         <Operations
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //         />
  //       );
  //     case "orgStructure":
  //       return (
  //         <OrgStructure
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={handleSetActiveSubKey}
  //           compView={compView}
  //           dataReportCheck={handleSubItemDataCheck}
  //         />
  //       );
  //     default:
  //       return null;
  //   }
  // };

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  const renderContent = () => {
    const currentTab = searchParams.get("tab") || activeParentTabKey;

    // normalize parent key
    let normalizedParent = activeParentTabKey;
    if (executiveSnapTabs.includes(currentTab)) {
      normalizedParent = "executiveSnap";
    } else if (marketPositionTabs.includes(currentTab)) {
      normalizedParent = "profileMarketPosition";
    } else if (productInnovationTabs.includes(currentTab)) {
      normalizedParent = "profileProductInnovation";
    } else if (financialTabs.includes(currentTab)) {
      normalizedParent = "financials";
    } else if (marketingDistributionTabs.includes(currentTab)) {
      normalizedParent = "marketing";
    } else if (operationsTabs.includes(currentTab)) {
      normalizedParent = "operations";
    } else if (orgStructureTabs.includes(currentTab)) {
      normalizedParent = "orgStructure";
    }

    switch (normalizedParent) {
      case "executiveSnap":
        return (
          <ExecutiveSnapshot
            handleTabChange={handleTabChange}
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            scrollContainerRef={scrollContainerRef}
            existingSubdimensions={existingSubdimensions}
            subdimensionStatus={subdimensionArray}
            registerDynamicTabs={registerDynamicTabs}
          />
        );
      case "news":
        return <News scrollTarget={scrollTarget} />;
      case "profileMarketPosition":
        return (
          <ProfileMarketPosition
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            registerDynamicTabs={registerDynamicTabs}
          />
        );
      case "profileProductInnovation":
        return (
          <ProfileProductInnovation
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            marketIqClient={marketIqClient}
            clientCompanyType={clientCompanyType}
            registerDynamicTabs={registerDynamicTabs}
          />
        );
      case "financials":
        return (
          <FinancialsComp
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            subItemDataStatus={subItemDataStatus}
            registerDynamicTabs={registerDynamicTabs}
            scrollContainerRef={scrollContainerRef}
          />
        );
      case "marketing":
        return (
          <Marketing
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            marketIqClient={marketIqClient}
            clientCompanyType={clientCompanyType}
            registerDynamicTabs={registerDynamicTabs}
          />
        );
      case "operations":
        return (
          <Operations
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            marketIqClient={marketIqClient}
            clientCompanyType={clientCompanyType}
            registerDynamicTabs={registerDynamicTabs}
          />
        );
      case "orgStructure":
        return (
          <OrgStructure
            activeSubKey={activeSubKey}
            setActiveSubKey={handleSetActiveSubKey}
            compView={compView}
            dataReportCheck={handleSubItemDataCheck}
            scrollTarget={scrollTarget}
            registerDynamicTabs={registerDynamicTabs}
          />
        );
      default:
        return null;
    }
  };
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  const tabItems = useMemo(
    () => [
      {
        key: "executiveSnap",
        label: "Executive Snapshot",
        icon: (
          <>
            <img
              src="/img/side_nav/excutive_snapshot.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {executiveSnapUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/excutive_snapshot_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          { key: "execCompanyOverviewTab", label: "Company Overview" },
          { key: "insightSummaryTab", label: "Insight Summary" },
          {
            key: "overallCompetitiveThreatAssessmentTab",
            label: "Overall Competitive Threat Assessment",
          },
          { key: "companyScorecardTab", label: "Company Scorecard" },
          {
            key: "businessSegmentStructureTab",
            label: "Business Segment Structure",
          },
          {
            key: "companyBaselineProfileTab",
            label: "Company Baseline Profile",
          },
          // {
          //   key: "competitiveIntelligenceDashboardTab",
          //   label: "Competitive Intelligence Dashboard",
          // },
          // {
          //   key: "executiveSummaryNextStepsTab",
          //   label: "Executive Summary & Next Steps",
          // },
          ...(dynamicTabsMap.executiveSnap || []),
        ],
      },
      {
        key: "profileMarketPosition",
        label: "Market Position & Customer Intelligence",
        icon: (
          <>
            <img
              src="/img/side_nav/market_position.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {proMarPositionUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/market_position_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          { key: "insightSummaryTabMp", label: "Insight Summary" },
          {
            key: "marketByTechnologyTab",
            label: "By Technology",
          },
          {
            key: "marketByApplicationTab",
            label: "By Application",
          },
          {
            key: "marketByGeographyTab",
            label: "By Geography",
          },
          { key: "marketShareAnalysisTab", label: "Market Share Analysis" },
          {
            key: "customerSegmentAnalysisTab",
            label: "Customer Segment Analysis",
          },
          {
            key: "keyExpansionsStrategicInitiativesTab",
            label: "Key Expansions & Strategic Initiatives",
          },
          ...(dynamicTabsMap.profileMarketPosition || []),
        ],
      },
      {
        key: "profileProductInnovation",
        label: "Product & Innovation",
        icon: (
          <>
            <img
              src="/img/side_nav/calendar.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {proProdInnovationUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/product_innovations_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          { key: "insightSummary", label: "Insight Summary" },
          {
            key: "productInnovationSolutions",
            label: "Product & Solutions Portfolio",
          },
          // {
          //   key: "compPosition",
          //   label: "Competitive Position Analysis",
          // },
          {
            key: "productLaunches",
            label: "Product Launches & Related Activities",
          },
          { key: "patentsIp", label: "Patents & IP Activity" },
          {
            key: "technologyCapability",
            label: "Technology Capability Assessment",
          },
          // {
          //   key: "customerValueProposition",
          //   label: "Customer Value Proposition Analysis",
          // },
          // { key: "strategicRiskMatrix", label: "Strategic Risk Matrix" },
          { key: "rdSpendEstimates", label: "R&D Spend Estimates" },
          { key: "rdFocus", label: "R&D Focus" },
          { key: "innovationTheme", label: "Innovation Theme Radar" },
          ...(dynamicTabsMap.profileProductInnovation || []),
        ],
      },
      {
        key: "financials",
        label: "Strategy & Financial Performance",
        icon: (
          <>
            <img
              src="/img/side_nav/dollar.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {financialsUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/finacials_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          {
            key: "strategicLeadershipThemesTab",
            label: "Strategic Leadership Themes",
          },
          { key: "financialsTable", label: "Financial Performance" },
          {
            key: "futureBetsLeadershipLedInitiativesTabf",
            label: "Future Bets & Leadership-Led Initiatives",
          },
          { key: "financialDocuments", label: "Financial Documents" },
          ...(dynamicTabsMap.financials || []),
        ],
      },
      {
        key: "marketing",
        label: "Marketing & Distribution",
        icon: (
          <>
            <img
              src="/img/side_nav/speaker.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {marketingUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/marketing_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          { key: "insightSummaryTabM", label: "Insight Summary" },
          { key: "gtmModelTab", label: "GTM Model" },
          {
            key: "distributionNetworksPartnershipsTab",
            label: "Distribution Networks & Partnerships",
          },
          {
            key: "channelMixUtilizationTab",
            label: "Channel Mix & Utilization",
          },
          {
            key: "demandGenerationAcquisitionTacticsTab",
            label: "Demand Generation & Acquisition Tactics",
          },
          {
            key: "marketingInvestmentROISignalsTab",
            label: "Marketing Investment & ROI Signals",
          },
          {
            key: "marketPresenceBrandSignalsTab",
            label: "Market Presence & Brand Signals",
          },
          { key: "messagingPositioningTab", label: "Messaging & Positioning" },
          {
            key: "digitalFootprintAnalysisTab",
            label: "Digital Footprint Analysis",
          },
          {
            key: "advertisingMediaSpendTab",
            label: "Advertising & Media Spend",
          },
          {
            key: "marketingChannelsbySegmentTab",
            label: "Marketing Channels by Segment",
          },
          {
            key: "marketingGeographicCoverageTab",
            label: "Marketing & Geographic Coverage",
          },
          ...(dynamicTabsMap.marketing || []),
        ],
      },
      {
        key: "operations",
        label: "Operations & Supply Chain",
        icon: (
          <>
            <img
              src="/img/side_nav/user.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {operationsUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/operations_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          { key: "operationsInsightTab", label: "Insight Summary" },
          { key: "quantSnapshotTab", label: "Quant Snapshot" },
          {
            key: "globalOperationsNetworkTab",
            label: "Global Operations Network",
          },
          // {
          //   key: "capexTrendsTab",
          //   label: "Capex Trends",
          // },
          { key: "tier1SuppliersTab", label: "Tier 1 Suppliers" },
          { key: "rawMaterialImportsTab", label: "Raw Material Imports" },
          { key: "inboundLogisticsTab", label: "Inbound Logistics" },
          { key: "warehousingChannelsTab", label: "Warehousing & Channels" },
          { key: "outboundDistributionTab", label: "Outbound Distribution" },
          { key: "tradeExposureTab", label: "Trade Exposure" },
          { key: "costStructureAnalysisTab", label: "Cost Structure Analysis" },
          {
            key: "sustainabilityFinanceInnovationRisksTab",
            label: "Sustainability, Finance, Innovation, Risks",
          },
          ...(dynamicTabsMap.operations || []),
        ],
      },
      {
        key: "orgStructure",
        label: "Corporate & Organizational Structure",
        icon: (
          <>
            <img
              src="/img/side_nav/vertical.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {orgStructureUpdate === 1 && <span className="new_dot"></span>}
            {/* {<span className="new_dot"></span>} */}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/org_structure_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        children: [
          // { key: "executiveTimelineTab", label: "Executive Timeline" },
          {
            key: "executiveLeadershipTeamTab",
            label: "Executive Leadership Team",
          },
          {
            key: "organizationalHierarchyTab",
            label: "Organizational Hierarchy",
          },
          // {
          //   key: "businessSegmentStructureTab",
          //   label: "Business Segment Structure",
          // },
          // {
          //   key: "strategicLeadershipThemesTab",
          //   label: "Strategic Leadership Themes",
          // },
          // {
          //   key: "futureBetsLeadershipLedInitiativesTab",
          //   label: "Future Bets & Leadership-Led Initiatives",
          // },
          ...(dynamicTabsMap.orgStructure || []),
        ],
      },
      {
        key: "news",
        label: "News",
        icon: (
          <>
            <img
              src="/img/side_nav/briefcase.png"
              alt={"icon"}
              className={`filter_icon`}
              style={{ width: "16px", marginRight: "7px" }}
            />
            {newsUpdate === 1 && <span className="new_dot"></span>}
          </>
        ),
        activeIcon: (
          <img
            src="/img/sidebar_icons/news_blue.png"
            alt={"icon"}
            className={`filter_icon`}
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
      },
    ],
    [dynamicTabsMap]
  );

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HIDING NAVIGATION LINKS BASED ON DATA AVAILABILITY CHECK

  // const filteredTabItems = useMemo(() => {
  //   // 1. Map over the main tabs
  //   return (
  //     tabItems
  //       .map((item) => {
  //         // If the item has children, process them
  //         if (item.children) {
  //           // 2. Filter the children based on the data status
  //           const filteredChildren = item.children.filter((child) => {
  //             // If a sub-item is not yet in the status map, assume it should show (or you can decide to hide it)
  //             const hasData = subItemDataStatus[child.key];

  //             // Only show if data is explicitly true or its status hasn't been reported yet.
  //             // It's safer to only show if a true status is reported to avoid showing empty items.
  //             // For initial load, you might want to show all until the check runs.
  //             // Here, we'll only hide if the status is explicitly false.
  //             return hasData !== false;
  //           });

  //           // 3. Return the parent item with the filtered children
  //           // A new object is necessary to avoid mutating the original `tabItems`
  //           return {
  //             ...item,
  //             children: filteredChildren,
  //           };
  //         }
  //         return item; // Item with no children is returned as is
  //       })
  //       // 4. Filter out any parent items that ended up with no children
  //       .filter((item) => {
  //         return !item.children || item.children.length > 0;
  //       })
  //   );
  // }, [tabItems, subItemDataStatus]); // Recalculate whenever status changes

  // const filteredTabItems = useMemo(() => {
  //   return tabItems
  //     .map((item) => {
  //       if (item.children) {
  //         const filteredChildren = item.children.filter((child) => {
  //           // PRIORITY 1 → existingSubdimensions
  //           if (useExistingSubdimensions) {
  //             const subdimensionName = subdimensionKeyMap[child.key];
  //             return existingSubdimensions?.data.includes(subdimensionName);
  //           } else {
  //             // PRIORITY 2 → data availability fallback
  //             const hasData = subItemDataStatus[child.key];
  //             return hasData !== false;
  //           }
  //         });

  //         return {
  //           ...item,
  //           children: filteredChildren,
  //         };
  //       }

  //       return item;
  //     })
  //     .filter((item) => !item.children || item.children.length > 0);
  // }, [
  //   tabItems,
  //   subItemDataStatus,
  //   existingSubdimensions,
  //   useExistingSubdimensions,
  // ]);

  // const filteredTabItems = useMemo(() => {
  //   // CASE 1: existingSubdimensions present → ONLY use mapping
  //   if (useExistingSubdimensions) {
  //     return tabItems
  //       .map((item) => {
  //         if (!item.children) return item;

  //         const filteredChildren = item.children.filter((child) => {
  //           if (useExistingSubdimensions) {
  //             const subdimensionName = subdimensionKeyMap[child.key];

  //             // COMPANY SCORECARD SPECIAL CASE
  //             if (child.key === "companyScorecardTab") {
  //               return scorecardElements.some((el) =>
  //                 existingSubdimensions?.data?.includes(el)
  //               );
  //             }

  //             return (
  //               subdimensionName &&
  //               existingSubdimensions?.data?.includes(subdimensionName)
  //             );
  //           }

  //           // fallback to data availability
  //           const hasData = subItemDataStatus[child.key];
  //           return hasData !== false;
  //         });

  //         return {
  //           ...item,
  //           children: filteredChildren,
  //         };
  //       })
  //       .filter((item) => !item.children || item.children.length > 0);
  //   }

  //   // CASE 2: fallback → data availability logic
  //   return tabItems
  //     .map((item) => {
  //       if (!item.children) return item;

  //       const filteredChildren = item.children.filter((child) => {
  //         const hasData = subItemDataStatus[child.key];
  //         return hasData !== false;
  //       });

  //       return {
  //         ...item,
  //         children: filteredChildren,
  //       };
  //     })
  //     .filter((item) => !item.children || item.children.length > 0);
  // }, [
  //   tabItems,
  //   subItemDataStatus,
  //   existingSubdimensions,
  //   useExistingSubdimensions,
  // ]);

  // Pseudocode:
  // 1. If useExistingSubdimensions is true:
  //    - Filter tabItems: only include tabs whose key is mapped and present in existingSubdimensions.data
  //    - For each tab, filter children (subtabs) similarly
  // 2. If useExistingSubdimensions is false:
  //    - Use fallback logic (data availability)

  // Debug: Log mapping and data
  // console.log("existingSubdimensions.data:", existingSubdimensions?.data);
  // console.log("tabItems:", tabItems);
  // console.log("subdimensionKeyMap:", subdimensionKeyMap);

  // const filteredTabItems = useMemo(() => {
  //   if (
  //     useExistingSubdimensions &&
  //     Array.isArray(existingSubdimensions?.data) &&
  //     existingSubdimensions.data.length > 0
  //   ) {
  //     return tabItems
  //       .filter((item) => {
  //         const dimensionName = subdimensionKeyMap[item.key];
  //         // If mapping fails, show tab (optional)
  //         if (!dimensionName) return true;
  //         return existingSubdimensions.data.includes(dimensionName);
  //       })
  //       .map((item) => {
  //         if (!item.children) return item;
  //         return {
  //           ...item,
  //           children: item.children.filter((child) => {
  //             const subdimensionName = subdimensionKeyMap[child.key];
  //             if (child.key === "companyScorecardTab") {
  //               return scorecardElements.some((el) =>
  //                 existingSubdimensions.data.includes(el)
  //               );
  //             }
  //             // If mapping fails, show subtab (optional)
  //             if (!subdimensionName) return true;
  //             return existingSubdimensions.data.includes(subdimensionName);
  //           }),
  //         };
  //       });
  //   }
  //   // Fallback: show all tabs if no data
  //   return tabItems;
  // }, [
  //   tabItems,
  //   useExistingSubdimensions,
  //   existingSubdimensions,
  //   subdimensionKeyMap,
  //   scorecardElements,
  // ]);

  const includesWithOrWithoutUnderscore = (arr, value) => {
    if (!value) return false;
    const valueNoUnderscore = value.replace(/_/g, "");
    return arr.includes(value) || arr.includes(valueNoUnderscore);
  };

  // const filteredTabItems = useMemo(() => {
  //   // CASE 1 → existingSubdimensions available
  //   if (useExistingSubdimensions) {
  //     return tabItems
  //       .map((item) => {
  //         if (!item.children) return item;

  //         const filteredChildren = item.children.filter((child) => {
  //           const subdimensionName = subdimensionKeyMap[child.key];

  //           // company scorecard special case
  //           if (child.key === "companyScorecardTab") {
  //             return scorecardElements.some((el) =>
  //               includesWithOrWithoutUnderscore(existingSubdimensions.data, el)
  //             );
  //           }

  //           if (!subdimensionName) return true;

  //           return includesWithOrWithoutUnderscore(
  //             existingSubdimensions.data,
  //             subdimensionName
  //           );
  //         });

  //         return {
  //           ...item,
  //           children: filteredChildren,
  //         };
  //       })
  //       .filter((item) => !item.children || item.children.length > 0);
  //   }

  //   // CASE 2 → fallback to data availability
  //   return tabItems
  //     .map((item) => {
  //       if (!item.children) return item;

  //       const filteredChildren = item.children.filter((child) => {
  //         const hasData = subItemDataStatus[child.key];
  //         return hasData !== false;
  //       });

  //       return {
  //         ...item,
  //         children: filteredChildren,
  //       };
  //     })
  //     .filter((item) => !item.children || item.children.length > 0);
  // }, [
  //   tabItems,
  //   useExistingSubdimensions,
  //   existingSubdimensions,
  //   subItemDataStatus,
  // ]);

  // const filteredTabItems = useMemo(() => {
  //   // CASE 1 → existingSubdimensions present
  //   if (useExistingSubdimensions) {
  //     return tabItems
  //       .map((item) => {
  //         if (!item.children) return item;

  //         const filteredChildren = item.children.filter((child) => {
  //           const subdimensionName = subdimensionKeyMap[child.key];

  //           // COMPANY SCORECARD SPECIAL CASE
  //           if (child.key === "companyScorecardTab") {
  //             const scorecardElements = [
  //               "FinancialsStrategy_ScoreCard",
  //               "MarketPosition_ScoreCard",
  //               "MarketingDistributions_ScoreCard",
  //               "OpsSupply_ScoreCard",
  //               "OrgLeader_ScoreCard",
  //               "ProdInno_ScoreCard",

  //               "FinancialsStrategy ScoreCard",
  //               "MarketPosition ScoreCard",
  //               "MarketingDistributions ScoreCard",
  //               "OpsSupply ScoreCard",
  //               "OrgLeader ScoreCard",
  //               "ProdInno ScoreCard",
  //             ];

  //             return scorecardElements.some((el) =>
  //               includesWithOrWithoutUnderscore(
  //                 existingSubdimensions?.data || [],
  //                 el
  //               )
  //             );
  //           }

  //           // OVERALL COMPETITIVE THREAT ASSESSMENT SPECIAL CASE
  //           if (child.key === "overallCompetitiveThreatAssessmentTab") {
  //             const threatElements = [
  //               "Overall_Competitive_Threat_Assessment",
  //               "Overall Competitive Threat Assessment",
  //             ];

  //             return threatElements.some((el) =>
  //               includesWithOrWithoutUnderscore(
  //                 existingSubdimensions?.data || [],
  //                 el
  //               )
  //             );
  //           }

  //           // NORMAL SUBTABS
  //           if (!subdimensionName) return true;

  //           return includesWithOrWithoutUnderscore(
  //             existingSubdimensions?.data || [],
  //             subdimensionName
  //           );
  //         });

  //         return {
  //           ...item,
  //           children: filteredChildren,
  //         };
  //       })
  //       .filter((item) => !item.children || item.children.length > 0);
  //   }

  //   // CASE 2 → fallback to data availability logic
  //   return tabItems
  //     .map((item) => {
  //       if (!item.children) return item;

  //       const filteredChildren = item.children.filter((child) => {
  //         const hasData = subItemDataStatus[child.key];
  //         return hasData !== false;
  //       });

  //       return {
  //         ...item,
  //         children: filteredChildren,
  //       };
  //     })
  //     .filter((item) => !item.children || item.children.length > 0);
  // }, [
  //   tabItems,
  //   useExistingSubdimensions,
  //   existingSubdimensions,
  //   subItemDataStatus,
  // ]);

  const filteredTabItems = useMemo(() => {
    // if (useExistingSubdimensions) {
    //   return tabItems
    //     .map((item) => {
    //       if (!item.children) return item;

    //       const filteredChildren = item.children.filter((child) => {
    //         const subdimensionName = subdimensionKeyMap[child.key];

    //         if (child.key === "companyScorecardTab") {
    //           return scorecardElements.some((el) =>
    //             includesWithOrWithoutUnderscore(
    //               existingSubdimensions?.data || [],
    //               el
    //             )
    //           );
    //         }

    //         if (child.key === "overallCompetitiveThreatAssessmentTab") {
    //           const threatElements = [
    //             "Overall_Competitive_Threat_Assessment",
    //             "Overall Competitive Threat Assessment",
    //           ];

    //           return threatElements.some((el) =>
    //             includesWithOrWithoutUnderscore(
    //               existingSubdimensions?.data || [],
    //               el
    //             )
    //           );
    //         }

    //         // if (!subdimensionName) return true;
    //         if (!subdimensionName) return false; // do NOT show unmapped tabs

    //         return includesWithOrWithoutUnderscore(
    //           existingSubdimensions?.data || [],
    //           subdimensionName
    //         );
    //       });

    //       return {
    //         ...item,
    //         children: filteredChildren,
    //       };
    //     })
    //     .filter((item) => {
    //       // ⬅⬅⬅ NEW CONDITION
    //       // hide parent if it has NO children and existingSubdimensions is present
    //       if (useExistingSubdimensions) {
    //         return !item.children || item.children.length > 0;
    //       }
    //       return true; // keep parent when existingSubdimensions is not present
    //     });
    // }
    if (useExistingSubdimensions) {
      return (
        tabItems
          .map((item) => {
            if (!item.children) return item;

            const filteredChildren = item.children.filter((child) => {
              const subdimensionName = subdimensionKeyMap[child.key];

              // 1. COMPANY SCORECARD SPECIAL CASE
              if (child.key === "companyScorecardTab") {
                const scorecardElements = [
                  "FinancialsStrategy_ScoreCard",
                  "MarketPosition_ScoreCard",
                  "MarketingDistributions_ScoreCard",
                  "OpsSupply_ScoreCard",
                  "OrgLeader_ScoreCard",
                  "ProdInno_ScoreCard",
                  "FinancialsStrategy ScoreCard",
                  "MarketPosition ScoreCard",
                  "MarketingDistributions ScoreCard",
                  "OpsSupply ScoreCard",
                  "OrgLeader ScoreCard",
                  "ProdInno ScoreCard",
                ];

                return scorecardElements.some((el) =>
                  includesWithOrWithoutUnderscore(
                    existingSubdimensions?.data || [],
                    el
                  )
                );
              }

              // 2. OVERALL COMPETITIVE THREAT ASSESSMENT
              if (child.key === "overallCompetitiveThreatAssessmentTab") {
                const t = [
                  "Overall_Competitive_Threat_Assessment",
                  "Overall Competitive Threat Assessment",
                ];

                return t.some((el) =>
                  includesWithOrWithoutUnderscore(
                    existingSubdimensions?.data || [],
                    el
                  )
                );
              }

              // if (!subdimensionName) return false;

              // Allow dynamic tabs
              if (child.isDynamic) return true;

              // old logic
              // 3. DO NOT KEEP UNMAPPED CHILDREN
              if (!subdimensionName) return false;

              // 4. Normal case: show only matched dimensions
              return includesWithOrWithoutUnderscore(
                existingSubdimensions?.data || [],
                subdimensionName
              );
            });

            return {
              ...item,
              children: filteredChildren,
            };
          })

          // REMOVE PARENT TABS WITH NO CHILDREN
          .filter((item) => !item.children || item.children.length > 0)
      );
    }

    // OLD BEHAVIOUR (no existingSubdimensions)
    return tabItems
      .map((item) => {
        if (!item.children) return item;

        const filteredChildren = item.children.filter((child) => {
          const hasData = subItemDataStatus[child.key];
          return hasData !== false;
        });

        return {
          ...item,
          children: filteredChildren,
        };
      })
      .filter((item) => {
        // ⬅⬅⬅ NEW CONDITION
        if (useExistingSubdimensions) {
          return !item.children || item.children.length > 0;
        }
        return true; // keep parent as-is
      });
  }, [
    tabItems,
    useExistingSubdimensions,
    existingSubdimensions,
    subItemDataStatus,
  ]);

  useEffect(() => {
    //   if (filteredTabItems.length) {
    const aiTablebuilderOptions = filteredTabItems.map((t) => t.label);
    setAiBuilderDimensionOptions(aiTablebuilderOptions);
    //   }
  }, [filteredTabItems, competitorName]);
  // console.log(
  //   "Available Parent Tabs →",
  //   filteredTabItems.map((t) => t.label)
  // );

  // const filteredTabItems = useMemo(() => {
  //   if (
  //     useExistingSubdimensions &&
  //     Array.isArray(existingSubdimensions?.data) &&
  //     existingSubdimensions.data.length > 0
  //   ) {
  //     return tabItems
  //       .filter((item) => {
  //         const dimensionName = subdimensionKeyMap[item.key];
  //         if (!dimensionName) return true;
  //         return includesWithOrWithoutUnderscore(
  //           existingSubdimensions.data,
  //           dimensionName
  //         );
  //       })
  //       .map((item) => {
  //         if (!item.children) return item;
  //         return {
  //           ...item,
  //           children: item.children.filter((child) => {
  //             const subdimensionName = subdimensionKeyMap[child.key];
  //             if (child.key === "companyScorecardTab") {
  //               return scorecardElements.some((el) =>
  //                 includesWithOrWithoutUnderscore(
  //                   existingSubdimensions.data,
  //                   el
  //                 )
  //               );
  //             }
  //             if (!subdimensionName) return true;
  //             return includesWithOrWithoutUnderscore(
  //               existingSubdimensions.data,
  //               subdimensionName
  //             );
  //           }),
  //         };
  //       });
  //   }
  //   return tabItems;
  // }, [
  //   tabItems,
  //   useExistingSubdimensions,
  //   existingSubdimensions,
  //   subdimensionKeyMap,
  //   scorecardElements,
  // ]);

  // HIDING NAVIGATION LINKS BASED ON DATA AVAILABILITY CHECK
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  const handleBackToAccounts = () => {
    navigate("/watchboard");
  };

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Add after the existing useEffects and before filteredTabItems useMemo

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // SEARCH FUNCTIONALITY
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // Build searchable sections from all tabs
  const buildSearchIndex = useCallback(() => {
    const searchIndex = [];

    filteredTabItems.forEach((tab) => {
      // Add parent tab to search
      searchIndex.push({
        key: tab.key,
        label: tab.label,
        parentKey: null,
        parentLabel: null,
      });

      // Add children to search
      if (tab.children && tab.children.length > 0) {
        tab.children.forEach((child) => {
          searchIndex.push({
            key: child.key,
            label: child.label,
            parentKey: tab.key,
            parentLabel: tab.label,
          });
        });
      }
    });

    return searchIndex;
  }, [filteredTabItems]);

  // Search handler

  const handleSearch = useCallback(
    (value) => {
      setSearchText(value);

      if (!value.trim()) {
        setSearchResults([]);
        setShowSuggestions(false);
        return;
      }

      const searchIndex = buildSearchIndex();
      const searchTerm = value.toLowerCase();

      const results = searchIndex.filter((item) => {
        const label = String(item?.label || "").toLowerCase();
        const parentLabel = String(item?.parentLabel || "").toLowerCase();

        return label.includes(searchTerm) || parentLabel.includes(searchTerm);
      });

      setSearchResults(results);
      setShowSuggestions(results.length > 0);
    },
    [buildSearchIndex]
  );

  // const handleSearch = useCallback(
  //   (value) => {
  //     setSearchText(value);

  //     if (!value.trim()) {
  //       setSearchResults([]);
  //       setShowSuggestions(false);
  //       return;
  //     }

  //     const searchIndex = buildSearchIndex();
  //     const searchTerm = value.toLowerCase();

  //     const results = searchIndex.filter((item) => {
  //       const labelMatch = item?.label?.toLowerCase().includes(searchTerm);
  //       const parentMatch = item?.parentLabel
  //         ?.toLowerCase()
  //         .includes(searchTerm);
  //       return labelMatch || parentMatch;
  //     });

  //     setSearchResults(results);
  //     setShowSuggestions(results.length > 0);
  //   },
  //   [buildSearchIndex]
  // );

  // Handle suggestion click
  // const handleSuggestionClick = useCallback(
  //   (item) => {
  //     // Close suggestions dropdown
  //     setShowSuggestions(false);
  //     setSearchText("");
  //     setSearchResults([]);

  //     // Navigate to the selected tab/section
  //     handleTabChange(item.key);

  //     // Set scroll target for child component to handle
  //     setScrollTarget({
  //       key: item.key,
  //       timestamp: Date.now(), // ensures fresh scroll even if same key
  //     });
  //   },
  //   [handleTabChange]
  // );

  const handleSuggestionClick = (item) => {
    setShowSuggestions(false);
    setSearchText("");

    setScrollTarget({
      key: item.key,
      timestamp: Date.now(),
    });

    if (item.type === "parent") {
      handleTabChange(item.key, true);
    } else {
      setExpandedKeys({ [item.parent]: true });
      handleTabChange(item.key, false);
    }
  };

  // Click outside to close suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      const searchBlock = document.querySelector(".search_tab_block");
      if (searchBlock && !searchBlock.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    dispatch(
      fetchNewUpdatesRequest({
        client: clientName,
        company: competitorName,
        user_id: user?.user_id,
        user_type:
          user?.demo === APP_CONFIG?.market_iq_demo ? "MarketIQ" : "CompIQ",
      })
    );
  }, []);
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="account-details-container">
      {/* Sidebar */}
      <div className="account-details-container-sidecard-container">
        {/* [START] => SEARCHBAR & SUGGESTION BLOCK */}
        <div className="search_tab_block mr-4">
          <div className="search_tab_subblock m-2">
            <FeatherIcon.Search className="search_feather" />
            <input
              type="search"
              autoComplete="off"
              placeholder="Search"
              className="search_tab_input"
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              onFocus={() => setShowSuggestions(true)}
            />
          </div>

          {showSuggestions && searchResults.length > 0 && (
            <div className="tab-search-suggestions notify-popup">
              <div
                style={{
                  borderBottom: "1px solid #E2E8F0",
                  color: "#4E6BCA",
                  fontWeight: "500",
                  fontSize: "12px",
                  padding: "16px",
                  // marginLeft: "15px",
                }}
              >
                Showing {searchResults.length} results
              </div>
              <div className="notify-list">
                {searchResults.map((item) => (
                  <div
                    key={item.key}
                    className="tab-search-item notify-item"
                    onClick={() => handleSuggestionClick(item)}
                  >
                    <span className="tab-search-label info name">
                      {item.parentLabel && (
                        <>
                          {item.parentLabel}{" "}
                          <FeatherIcon.ChevronRight width="16" height="16" />
                        </>
                      )}
                      <strong>{item.label}</strong>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {/* [END] => SEARCHBAR & SUGGESTION BLOCK */}

        <div className="sidebar_left_container">
          <Nav className="account-tabs-nav">
            {/* The filteredTabItems array already contains parent objects
                where the 'children' property is the filtered array. */}
            {filteredTabItems
              .filter(
                (tab) =>
                  // clientName !== "Oracle Corporation" ||
                  // clientName !== marketIqClient ||
                  clientCompanyType !== APP_CONFIG.market_iq_demo ||
                  !nonMarketIqTabs.includes(tab.key)
              )
              .map((tab) => {
                return (
                  <div key={tab.key}>
                    <Nav.Link
                      // ... (omitted for brevity)
                      onClick={() => handleTabChange(tab.key, !!tab.children)}
                    >
                      <div
                        className={`account-tab-item-content
                        ${
                          // Use tab.children here which is the filtered list
                          tab.children?.some((c) => c.key === activeSubKey)
                            ? "blue_top"
                            : ""
                        }
                        `}
                      >
                        {/* ... (icon and label content) */}
                        <span className="icon_left_sub">
                          {activeParentTabKey === tab.key ||
                          // Use tab.children here which is the filtered list
                          tab.children?.some((c) => c.key === activeSubKey)
                            ? tab.activeIcon || tab.icon // fallback to normal icon
                            : tab.icon}
                        </span>
                        {tab.label}
                        {/* Use tab.children here which is the filtered list */}
                        {tab.children?.length > 0 && (
                          <span className="dropdown-arrow">
                            {expandedKeys[tab.key] ? (
                              <FeatherIcon.ChevronRight
                                width="16"
                                height="16"
                              />
                            ) : (
                              <FeatherIcon.ChevronDown width="16" height="16" />
                            )}
                          </span>
                        )}
                      </div>
                    </Nav.Link>

                    {/* CRITICAL FIX: Ensure you check if the filtered children list has items
                      before rendering the submenu, and then map over the filtered list (tab.children) */}
                    {tab.children?.length > 0 && expandedKeys[tab.key] && (
                      <div className="submenu">
                        {/* tab.children here is the list that was already filtered 
                          in your useMemo hook, so it correctly omits items with no data. */}
                        {tab.children
                          .filter(
                            (tab) =>
                              // clientName !== "Oracle Corporation" ||
                              // clientName !== marketIqClient ||
                              clientCompanyType !== APP_CONFIG.market_iq_demo ||
                              !nonMarketIqSubTabs.includes(tab.key)
                          )

                          .map((child) => (
                            <div
                              key={child.key}
                              className={`submenu-item 
                        ${activeSubKey === child.key ? "active blue" : ""}
                        ${
                          // Use tab.children here which is the filtered list
                          tab.children?.some((c) => c.key === activeSubKey)
                            ? "blue"
                            : ""
                        }
                      `}
                              // onClick={() => {
                              //   handleTabChange(child.key);
                              //   setExpandedKeys({ [tab.key]: true }); // keep only this parent open
                              // }}
                              onClick={() => {
                                handleTabChange(child.key);
                                setExpandedKeys({ [tab.key]: true });

                                setScrollTarget({
                                  key: child.key,
                                  timestamp: Date.now(),
                                });
                              }}
                            >
                              {child.label}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                );
              })}
          </Nav>
        </div>
      </div>

      {/* Content Area */}
      <div
        className="account-details-container-content"
        ref={scrollContainerRef}
      >
        {displayCompProfileUpdatesSection && (
          <NewCompProfileUpdates
            action={selectedAction}
            data={subdimensionArray}
            onActionChange={handleActionChange}
          />
        )}
        {renderContent()}
      </div>
    </div>
  );
}

export default React.memo(CompProfileTabs);
